<template lang="pug">
  div
    doc-markdown(source=`
    ## Colors
    Seraphin color system is based on [Tailwind colors](https://tailwindcss.com/docs/customizing-colors). It's composed of base colors (gray, red, green, blue...) with their variation, \`500\` is the main color with its lighter variations from \`100\` to \`400\` and its darker variations from \`600\` to \`900\`.

    The color system also includes black, white, transparent and the \`currentColor\` keyword.

    To apply theses colors to an element, use [Tailwind utility classes](https://tailwindcss.com/docs/text-color).

    For example:

    - \`text-*\` : for the text \`color\` property
    - \`bg-*\` : for the \`background\` property
    - \`border-*\` : for the \`border-color\` property
    `)
    .text-2xl.font-bold.text-gray-900.mb-4 All colors
    .grid.gap-10(class="sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5")
      .text-base.font-bold.text-gray-900(class="sm:col-span-2 md:col-span-3 lg:col-span-4 xl:col-span-5") Base colors
      template(v-for="(color, name) in theme.colors")
        .flex.items-center(v-if="typeof(color) === 'string'")
          .w-12.h-12.rounded.shadow-inner(:style="{background: color}")
          .ml-3
            .text-sm {{ name }}
            .text-xs.text-gray-600 {{ color }}
        template(v-else)
          .text-base.font-bold.text-gray-900(class="sm:col-span-2 md:col-span-3 lg:col-span-4 xl:col-span-5") {{ formatText(name) }}
          .flex.items-center(v-for="(value, type) in color")
            .w-12.h-12.rounded.shadow-inner(:style="{background: value}")
            .ml-3
              .text-sm {{ name }}-{{ type }}
              .text-xs.text-gray-600 {{ value }}
</template>

<script>
  import { theme } from '../../../../tailwind.config';

  export default {
    data () {
      return {
        theme,
      };
    },
    methods: {
      formatText (string) {
        string = string.replace('-', ' ');
        string = string.charAt(0).toUpperCase() + string.slice(1);
        return string;
      },
    },
  };
</script>
